module.exports = __webpack_public_path__ + "img/zhongYao5.492a1225.png";